/* eslint-disable */
// @ts-nocheck
(function() {
    const host = window.location.host;

    var isDebug = false;
    var requestId = 1; // 请求ID，自增唯一
    var yodaSDKReady = false; // yoda SDK 是否加载完成
    var yodaVerifying = false; // 当前是否在验证流程中
    var yodaSuccessCallback = []; // 验证成功回调列表
    var requestsInProgress = {}; // 符合反扒名单且在进行中的请求
    var antiSpiderPaths = [
        // 需要进行反扒检测的接口列表
        '/api/poi/poiList',
        '/v2/index/r/analysis/rank',
        '/v2/index/r/businessOverview',
        '/v2/order/pre/r/query',
        '/v2/order/receive/r/chargeInfo',
        '/v2/order/refund/list/v2',
        '/v2/order/receive/r/distribute/getArrivedStatus',
        '/v2/order/receive/processed/r/querywithin3h',
        '/v2/order/receive/processed/r/dispatcherPhone',
        '/v2/order/history/r/search/ajax',
        '/v2/order/history/r/query',
    ];

    window.yodaSuccessCallback = yodaSuccessCallback;

    // 加载自定义样式
    var head = document.getElementsByTagName('head')[0];
    var styleEl = document.createElement('style');
    styleEl.setAttribute('type', 'text/css');
    styleEl.appendChild(
        document.createTextNode(
            '#__yoda_modal { z-index: 9999; } .yoda-slider-wrapper { border-radius: 2px; box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5); }',
        ),
    );
    head.appendChild(styleEl);

    function updateURLParam(url, param, paramVal) {
        if (paramVal === null || paramVal === undefined) {
            paramVal = '';
        }

        if (
            typeof url === 'string' &&
            typeof param === 'string' &&
            (typeof paramVal === 'string' ||
                typeof paramVal === 'boolean' ||
                typeof paramVal === 'number')
        ) {
            var TheAnchor = null;
            var newAdditionalURL = '';
            var tempArray = url.split('?');
            var baseURL = tempArray[0];
            var additionalURL = tempArray[1];
            var temp = '';
            var tmpAnchor = '';
            var TheParams = '';

            if (additionalURL) {
                tmpAnchor = additionalURL.split('#');
                TheParams = tmpAnchor[0];
                TheAnchor = tmpAnchor[1];

                if (TheAnchor) {
                    additionalURL = TheParams;
                }

                tempArray = additionalURL.split('&');

                for (var i = 0; i < tempArray.length; i++) {
                    if (tempArray[i].split('=')[0] !== param) {
                        newAdditionalURL += temp + tempArray[i];
                        temp = '&';
                    }
                }
            } else {
                tmpAnchor = baseURL.split('#');
                TheParams = tmpAnchor[0];
                TheAnchor = tmpAnchor[1];

                if (TheParams) {
                    baseURL = TheParams;
                }
            }

            if (TheAnchor) {
                paramVal += '#' + TheAnchor;
            }

            var rowsTxt = temp + '' + param + '=' + paramVal;
            return baseURL + '?' + newAdditionalURL + rowsTxt;
        } else {
            return url;
        }
    }

    var deviceUuid = getCookie('device_uuid') || '';
    var objectToString = Object.prototype.toString;
    var MSTI_PARAMS = {
        optimus_uuid: deviceUuid.replace('!', ''),
        optimus_risk_level: 71,
        optimus_code: 10,
        optimus_partner: 19,
    };

    function addMTSIParamsToUrl(url) {
        var finalUrl = url;
        Object.keys(MSTI_PARAMS).forEach(function(key) {
            finalUrl = updateURLParam(finalUrl, key, MSTI_PARAMS[key]);
        });
        return finalUrl;
    }

    function addMSTIParamsToPostBody(body) {
        var dataTypeStr = objectToString.call(body);

        if (dataTypeStr === '[object String]') {
            Object.keys(MSTI_PARAMS).forEach(function(key) {
                body = body + '&' + key + '=' + MSTI_PARAMS[key];
            });

            return body.replace(/^\&/, '');
        } else if (dataTypeStr === '[object FormData]') {
            Object.keys(MSTI_PARAMS).forEach(function(key) {
                body.append(key, MSTI_PARAMS[key]);
            });
            return body;
        } else if (dataTypeStr === '[object Object]') {
            return Object.assign({}, body, MSTI_PARAMS);
        } else {
            console.warn('添加反爬参数异常，未知请求数据类型');
            return body;
        }
    }

    // 加载 yoda SDK
    var yodaSDKScriptTag = document.createElement('script');
    yodaSDKScriptTag.onload = function() {
        yodaSDKReady = true;
    };
    yodaSDKScriptTag.src = 'https://s0.meituan.net/mxx/yoda/yoda.seed.js';
    document.head.appendChild(yodaSDKScriptTag);

    // 创建验证弹框容器
    var yodaModalContainerEl = document.createElement('div');
    yodaModalContainerEl.id = '__yoda_modal';
    yodaModalContainerEl.style.display = 'none';
    document.body.appendChild(yodaModalContainerEl);

    // 验证成功回调
    window.YodaSeedSuccessCallback = function() {
        setTimeout(function() {
            var callbacks = yodaSuccessCallback.slice();
            yodaSuccessCallback = [];
            callbacks.forEach(function(callback) {
                callback();
            });
            yodaVerifying = false;
            yodaModalContainerEl.style.display = 'none';
        }, 100);
    };

    try {
        var XHR = window.XMLHttpRequest;
        if (!XHR) {
            // 似乎哪里不对
            return;
        }
        // 防止二次初始化
        if ('_anti_spider_enabled' in XHR) {
            console.warn('反扒模块重复初始化');
            return;
        }
        XHR._anti_spider_enabled = true;

        // 不拦截 file 协议页面
        var protocol = window.location.protocol;
        if (protocol === 'file:') {
            return;
        }

        var originalXHROpen = XHR.prototype.open;
        var originalXHRSetRequestHeader = XHR.prototype.setRequestHeader;
        var originalXHRSend = XHR.prototype.send;

        XHR.prototype.open = function(method, url, async) {
            var requestPath = url.replace(/\?.*$/, '');
            var isGet = (method || '').toLowerCase() === 'get';
            var finalUrl = url;

            // 如果是重试请求则不拦截
            if (!this._retry_request) {
                if (antiSpiderPaths.indexOf(requestPath) !== -1) {
                    // 命中反扒名单
                    if (isDebug) {
                        console.log('[反扒] open -> ' + requestPath);
                    }
                    this._anti_spider_request_id = requestId++;

                    // GET 请求则在URL中增加反扒参数
                    if (isGet) {
                        finalUrl = addMTSIParamsToUrl(url);
                    }

                    // 保存请求信息，以便后续重试
                    var requestInfo = {
                        method: method,
                        url: finalUrl,
                        headers: {},
                    };

                    requestsInProgress[this._anti_spider_request_id] = requestInfo;
                }
            } else {
                if (isDebug) {
                    console.log('[反扒] retry -> ' + requestPath);
                }
            }

            return originalXHROpen.apply(this, [method, finalUrl, async]);
        };

        XHR.prototype.setRequestHeader = function(header, value) {
            if (typeof this._anti_spider_request_id === 'number') {
                // 记录自定义Header用于重试
                var requestInfo = requestsInProgress[this._anti_spider_request_id];

                if (requestInfo) {
                    if (isDebug) {
                        console.log(
                            '[反扒] setRequestHeader [' +
                                requestInfo.url +
                                '] -> ' +
                                header +
                                ':' +
                                value,
                        );
                    }

                    requestInfo.headers[header] = value;
                }
            }

            return originalXHRSetRequestHeader.apply(this, arguments);
        };

        XHR.prototype.send = function(body) {
            var originalXHR = this;
            if (typeof originalXHR._anti_spider_request_id === 'number') {
                var requestInfo = requestsInProgress[this._anti_spider_request_id];

                if (requestInfo) {
                    if (isDebug) {
                        console.log('[反扒] send [' + requestInfo.url + '] -> ' + body);
                    }

                    // 如果是POST请求，在body中增加反扒参数
                    if (requestInfo.method.toLowerCase() === 'post') {
                        body = addMSTIParamsToPostBody(body);
                    }

                    requestInfo.body = body;
                }

                // 这里要 setTimeout 一下是因为 jQuery 1.10.2 里时先 send 后设置 onreadystatechagne。。。
                // 源码参见：https://github.com/jquery/jquery/blob/1.10.2/src/ajax/xhr.js#L100-L103

                /**
                 * jQuery 1.10.2 使用的是 [onreadystatechange](https://github.com/jquery/jquery/blob/1.10.2/src/ajax/xhr.js#L195)
                 * vue-resource 1.3.4 使用的是 [onload](https://github.com/pagekit/vue-resource/blob/1.3.4/src/http/client/xhr.js#L59)
                 *
                 * 所以两个都需要拦截
                 */

                var originalOnLoadHandler = originalXHR['onload'];
                var originalOnreadystatechange = originalXHR['onreadystatechange'];
                var onreadystatechangeAddedAfterSend;
                originalXHR['onload'] = function() {
                    // 覆盖原有逻辑，改为由 onreadystatechange 内触发原有 onload 回调
                    // SO上的讨论：https://stackoverflow.com/questions/9181090/is-onload-equal-to-readystate-4-in-xmlhttprequest
                };

                function newOnreadyStateChange() {
                    if (
                        originalXHR.readyState === 4 &&
                        typeof originalXHR._anti_spider_request_id === 'number'
                    ) {
                        try {
                            if (originalXHR.status === 200) {
                                // 只处理正常响应
                                var responseText =
                                    originalXHR.responseType === 'text' ||
                                    originalXHR.responseType === ''
                                        ? originalXHR.responseText
                                        : '{}';
                                var responseJSON = {};
                                try {
                                    responseJSON = JSON.parse(responseText);
                                } catch (e) {}

                                if (responseJSON.code === 406) {
                                    // 命中反扒
                                    if (yodaSDKReady) {
                                        var customData = responseJSON.customData || {};
                                        var yodaRequestCode = customData.requestCode;
                                        // 注册验证通过回调
                                        yodaSuccessCallback.push(function() {
                                            // 重新重试请求
                                            var retryRequest = new XMLHttpRequest();
                                            retryRequest._retry_request = true; // 标记重试请求，绕过拦截，务必在 .open 之前加标识
                                            retryRequest.open(requestInfo.method, requestInfo.url);
                                            Object.keys(requestInfo.headers).forEach(function(k) {
                                                retryRequest.setRequestHeader(
                                                    k,
                                                    requestInfo.headers[k],
                                                );
                                            });
                                            retryRequest.onload = function() {
                                                if (this.readyState === 4) {
                                                    var responseText =
                                                        this.responseType === 'text' ||
                                                        this.responseType === ''
                                                            ? this.responseText
                                                            : '{}';
                                                    var responseJSON = {};
                                                    try {
                                                        responseJSON = JSON.parse(responseText);
                                                    } catch (e) {}

                                                    if (responseJSON.code === 406) {
                                                        // 重试依然 406，尝试刷新页面
                                                        window.location.reload();
                                                    } else if (
                                                        originalOnLoadHandler ||
                                                        originalOnreadystatechange ||
                                                        onreadystatechangeAddedAfterSend
                                                    ) {
                                                        if (Object.defineProperty) {
                                                            Object.defineProperty(
                                                                originalXHR,
                                                                'responseText',
                                                                {
                                                                    get: function() {
                                                                        return retryRequest.responseText;
                                                                    },
                                                                },
                                                            );
                                                            Object.defineProperty(
                                                                originalXHR,
                                                                'response',
                                                                {
                                                                    get: function() {
                                                                        return retryRequest.response;
                                                                    },
                                                                },
                                                            );
                                                            Object.defineProperty(
                                                                originalXHR,
                                                                'getAllResponseHeaders',
                                                                {
                                                                    get: function() {
                                                                        return function() {
                                                                            return retryRequest.getAllResponseHeaders();
                                                                        };
                                                                    },
                                                                },
                                                            );
                                                        }
                                                        if (originalOnLoadHandler) {
                                                            originalOnLoadHandler.apply(
                                                                originalXHR,
                                                            );
                                                        }
                                                        if (originalOnreadystatechange) {
                                                            originalOnreadystatechange.apply(
                                                                originalXHR,
                                                            );
                                                        }
                                                        if (onreadystatechangeAddedAfterSend) {
                                                            onreadystatechangeAddedAfterSend.apply(
                                                                originalXHR,
                                                            );
                                                        }
                                                    }
                                                }
                                            };
                                            retryRequest.send(requestInfo.body);
                                        });

                                        if (!yodaVerifying) {
                                            yodaModalContainerEl.style.display = 'block';
                                            yodaVerifying = true;
                                            window.YodaSeed(
                                                {
                                                    requestCode: yodaRequestCode,
                                                    succCallbackFun: 'YodaSeedSuccessCallback',
                                                    failCallbackFun: function() {},
                                                    root: '__yoda_modal',
                                                    theme: 'waimai',
                                                },
                                                isDebug ? 'test' : undefined,
                                            );
                                        }

                                        return;
                                    } else {
                                        // yoda SDK 还没准备好
                                        delete requestsInProgress[
                                            originalXHR._anti_spider_request_id
                                        ];
                                    }
                                } else {
                                    // 未命中反扒
                                    delete requestsInProgress[originalXHR._anti_spider_request_id];

                                    if (originalOnLoadHandler) {
                                        originalOnLoadHandler.apply(originalXHR);
                                    }
                                }
                            } else {
                                // 非 200 响应不作处理
                                delete requestsInProgress[originalXHR._anti_spider_request_id];
                            }
                        } catch (e) {}
                    }

                    if (originalOnreadystatechange) {
                        originalOnreadystatechange.apply(originalXHR, arguments);
                    }
                    if (onreadystatechangeAddedAfterSend) {
                        onreadystatechangeAddedAfterSend.apply(originalXHR);
                    }
                }

                if (Object.defineProperty) {
                    Object.defineProperty(originalXHR, 'onreadystatechange', {
                        get: function() {
                            return newOnreadyStateChange;
                        },
                        set: function(func) {
                            onreadystatechangeAddedAfterSend = func;

                            if (originalXHR.readyState === 4) {
                                func.apply(originalXHR);
                            }
                        },
                        enumerable: true,
                    });
                }

                originalXHR.addEventListener('readystatechange', newOnreadyStateChange);
            }

            return originalXHRSend.apply(originalXHR, [body]);
        };
    } catch (e) {
        // BOOM
    }
})();

export default null;
